import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Field, inputCls } from "@/components/LegsEditor";
import { useApi, errMsg } from "@/lib/api";

const KEYS = [["operator_name", "Operator name"], ["operator_trip_id", "Operator trip ID"], ["operator_phone", "Operator phone"], ["tail_number", "Tail number"], ["operator_address", "Operator address"]];

export function OperatorDialog({ open, t, onClose, onSaved }) {
  const api = useApi();
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF(Object.fromEntries(KEYS.map(([k]) => [k, t.aircraft[k] || ""]))); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!open || !f) return null;
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      onSaved((await api.patch(`/tracking/${t.id}/aircraft`, f)).data);
      toast.success("Operator details saved");
      onClose();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="bg-[#111319] border-white/10 max-w-xl max-h-[92vh] overflow-y-auto" data-testid="operator-dialog">
        <DialogHeader>
          <p className="eyebrow">{t.trip_ref}</p>
          <DialogTitle className="font-serif-display text-3xl font-normal text-white">Operator details</DialogTitle>
        </DialogHeader>
        <form onSubmit={save} className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2">
          {KEYS.map(([k, label]) => (
            <div key={k} className={k === "operator_address" ? "sm:col-span-2" : ""}>
              <Field label={label}>
                <Input className={inputCls} value={f[k]} maxLength={k === "operator_address" ? 300 : k === "tail_number" ? 20 : k === "operator_phone" ? 40 : 160}
                  onChange={(e) => setF((x) => ({ ...x, [k]: e.target.value }))} data-testid={`operator-${k}-input`} />
              </Field>
            </div>
          ))}
          <div className="sm:col-span-2 flex justify-end gap-3 mt-2">
            <button type="button" className="frame-btn" onClick={onClose} data-testid="operator-cancel-btn">Cancel</button>
            <button type="submit" className="frame-btn gold" disabled={busy} data-testid="operator-save-btn">{busy ? "Saving…" : "Save details"}</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
